// pageInside/payments/CheckoutPaymentMethods.jsx
//
// ONE dynamic payment slot inside the existing Checkout Modal (never a
// second modal). When Stripe is the only method actually available, this
// renders nothing but the existing Stripe content -- no selector, no empty
// space -- so the checkout looks and behaves exactly as before.
import React from "react";
import { FaApplePay, FaCreditCard, FaGooglePay, FaPaypal } from "react-icons/fa";
import { elakayAutoText } from "../dataElakay";
import { shouldShowMethodSelector } from "./paymentMethodsLogic";
import "./payments.css";

export const checkoutMethodLabel = (method) => ({
  stripe: elakayAutoText("h_pay_card", "Credit or Debit Card"),
  paypal: elakayAutoText("h_pay_paypal", "PayPal"),
  googlePay: elakayAutoText("h_pay_google_pay", "Google Pay"),
  applePay: elakayAutoText("h_pay_apple_pay", "Apple Pay"),
}[method] || method);

const ICONS = { stripe: FaCreditCard, paypal: FaPaypal, googlePay: FaGooglePay, applePay: FaApplePay };

export const checkoutMethodActionLabel = (method) => ({
  stripe: elakayAutoText("h_pay_with_card", "Pay with a credit or debit card"),
  paypal: elakayAutoText("h_pay_with_paypal", "Pay with PayPal"),
  googlePay: elakayAutoText("h_pay_with_google_pay", "Pay with Google Pay"),
  applePay: elakayAutoText("h_pay_with_apple_pay", "Pay with Apple Pay"),
}[method] || method);

const CheckoutPaymentMethods = ({ methods = ["stripe"], selected = "stripe", onSelect, children }) => {
  if (!shouldShowMethodSelector(methods)) return <>{children}</>;
  return (
    <div className="elk-pay-methods">
      <div className="elk-pay-methods__title" id="elk-pay-methods-title">
        {elakayAutoText("h_pay_select_method", "Select Payment Method")}
      </div>
      <div className="elk-pay-methods__row" role="radiogroup" aria-labelledby="elk-pay-methods-title">
        {methods.map((method) => {
          const Icon = ICONS[method] || FaCreditCard;
          const active = method === selected;
          return (
            <button
              key={method}
              type="button"
              role="radio"
              aria-checked={active}
              title={checkoutMethodActionLabel(method)}
              className={`elk-pay-methods__option${active ? " is-active" : ""}`}
              onClick={() => onSelect && onSelect(method)}
            >
              <Icon aria-hidden="true" className="elk-pay-methods__icon" />
              <span>{checkoutMethodLabel(method)}</span>
            </button>
          );
        })}
      </div>
      <div className="elk-pay-methods__panel">{children}</div>
    </div>
  );
};

export default CheckoutPaymentMethods;
